/*
 * ##### Flatpicker #####
 */

window.initDatePicker = function(selector, options = {}) {
  let canInit = true;
  if (typeof selector !== 'object' && !document.querySelector(selector)) { //c'est un nom de classe donc on vérifie que l'élément existe
    canInit = false;
  }

  if (canInit) {
    return flatpickr(selector, {
      locale: "fr",
      disableMobile: true, // Prevents mobile default picker
      ...options,
      onReady: (selectedDates, dateStr, instance) => {
        updateMonthYearText(instance);
        customizeWeekdayLabels(instance);
        setupAccessibility(instance);
        if (options.onReady) options.onReady(selectedDates, dateStr, instance);
      },
      onMonthChange: (selectedDates, dateStr, instance) => {
        updateMonthYearText(instance);
        setupAccessibility(instance);
        if (options.onMonthChange) options.onMonthChange(selectedDates, dateStr, instance);
      },
      onYearChange: (selectedDates, dateStr, instance) => {
        updateMonthYearText(instance);
        setupAccessibility(instance);
        if (options.onYearChange) options.onYearChange(selectedDates, dateStr, instance);
      }
    });
  }
}

// Standard function to update month & year text
function updateMonthYearText(instance) {
  setTimeout(() => {
    if (!instance) return;

    const monthElement = instance.calendarContainer.querySelector(".flatpickr-month");
    if (!monthElement) return;

    // Remove existing custom month-year text
    const existingText = monthElement.querySelector(".custom-month-year");
    if (existingText) existingText.remove();

    const textElement = document.createElement("span");
    textElement.classList.add("custom-month-year");

    const monthNames = instance.l10n.months.longhand;
    const currentMonth = monthNames[instance.currentMonth];
    const currentYear = instance.currentYear;

    textElement.textContent = `${currentMonth} ${currentYear}`;
    monthElement.insertBefore(textElement, monthElement.firstChild);
  }, 10);
}

// Standard function to customize weekday labels
function customizeWeekdayLabels(instance) {
  setTimeout(() => {
    if (!instance) return;

    const weekdayElements = instance.calendarContainer.querySelectorAll(".flatpickr-weekday");
    const fullNames = instance.l10n.weekdays.longhand;
    const shortNames = ["D", "L", "M", "M", "J", "V", "S"]; // Custom uppercase initials

    weekdayElements.forEach((el, index) => {
      el.textContent = shortNames[index]; // Replace text
      el.setAttribute("aria-label", fullNames[index]); // Add ARIA label
    });
  }, 10);
}

// Standard function to set up accessibility
function setupAccessibility(instance) {
  setTimeout(() => {
    if (!instance) return;

    const prevBtn = instance.calendarContainer.querySelector(".flatpickr-prev-month");
    const nextBtn = instance.calendarContainer.querySelector(".flatpickr-next-month");

    if (prevBtn && nextBtn) {
      prevBtn.setAttribute("tabindex", "0");
      nextBtn.setAttribute("tabindex", "0");

      updateAriaLabels(instance, prevBtn, nextBtn);

      prevBtn.removeEventListener("keydown", handleNavKeydown);
      nextBtn.removeEventListener("keydown", handleNavKeydown);

      prevBtn.addEventListener("keydown", handleNavKeydown);
      nextBtn.addEventListener("keydown", handleNavKeydown);
    }
  }, 10);
}

// Standard function to update ARIA labels
function updateAriaLabels(instance, prevBtn, nextBtn) {
  if (!instance) return;

  const monthNames = instance.l10n.months.longhand;
  const currentMonth = instance.currentMonth;
  const currentYear = instance.currentYear;

  const prevMonthIndex = (currentMonth - 1 + 12) % 12;
  const nextMonthIndex = (currentMonth + 1) % 12;
  const prevYear = currentMonth === 0 ? currentYear - 1 : currentYear;
  const nextYear = currentMonth === 11 ? currentYear + 1 : currentYear;

  prevBtn.setAttribute("aria-label", `Mois précédent : ${monthNames[prevMonthIndex]} ${prevYear}`);
  nextBtn.setAttribute("aria-label", `Mois suivant : ${monthNames[nextMonthIndex]} ${nextYear}`);
}

// Standard function to handle keyboard navigation
function handleNavKeydown(e) {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    e.target.click();
    setTimeout(() => {
      setupAccessibility(document.querySelector(".access-datepicker")._flatpickr);
    }, 10);
  }
}

if (document.querySelector('.access-datepicker')) {
  const datePicker = initDatePicker(".access-datepicker", {
    inline: true,
    minDate: "today",
    mode: "range",
    appendTo: document.querySelectorAll(".range-picker"),
  });


  document.querySelector(".range-picker").addEventListener("keydown", (e) => {
    const instance = document.querySelector('.access-datepicker')._flatpickr;
    if (!instance) return;

    const prevBtn = instance.calendarContainer.querySelector(".flatpickr-prev-month");
    const nextBtn = instance.calendarContainer.querySelector(".flatpickr-next-month");

    if (e.key === "ArrowLeft" && prevBtn) {
      prevBtn.click();
      setupAccessibility(instance);
    } else if (e.key === "ArrowRight" && nextBtn) {
      nextBtn.click();
      setupAccessibility(instance);
    }
  });
}

if (document.querySelector('.select-date-input')) {

  document.querySelectorAll('.select-date-input').forEach((item) => {
    let options = {
      dateFormat: "d/m/Y"
    };

    if (item.dataset.mindate) {
      options.minDate = item.dataset.mindate;
    }

    if (item.dataset.maxdate) {
      options.maxDate = item.dataset.maxdate;
    }

    initDatePicker(item, options) ;

    // Ensure clicking the icon also triggers the calendar
    item.parentNode.querySelector(".btn-calendar").addEventListener("click", function () {
      //récupération de l'input "DatePicker" lié
      const datePicker = this.parentNode.previousElementSibling._flatpickr;
      datePicker.open();
    });
  });
}
